import { API_BASE_URL } from '../config';
import { getAdminToken, clearAdminToken } from '../utils/authStorage';

export async function adminLogin(password) {
  const response = await fetch(`${API_BASE_URL}/admin/auth/login`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ password }),
  });
  const payload = await response.json();
  if (!response.ok || Number(payload.code) !== 0) {
    throw new Error(payload.message || `HTTP ${response.status}`);
  }
  return payload.data;
}

export async function adminRequest(path, options = {}) {
  const { body, headers = {}, ...rest } = options;
  const token = getAdminToken();
  const init = {
    ...rest,
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...headers,
    },
  };
  if (body !== undefined) {
    init.body = JSON.stringify(body);
  }
  const response = await fetch(`${API_BASE_URL}${path}`, init);
  const payload = await response.json();
  if (response.status === 401 || response.status === 403) {
    clearAdminToken();
  }
  if (!response.ok || Number(payload.code) !== 0) {
    throw new Error(payload.message || `HTTP ${response.status}`);
  }
  return payload.data;
}
